import { ofType } from 'redux-observable';
import { merge } from 'rxjs';
import { ignoreElements, map, take, tap } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';

export function updateLanguageForAccessibilityEpic(): SpEpic {
  return action$ => {
    const firstUserPreferencesReceived$ = action$.pipe(ofType('USER_PREFERENCES_RECEIVED'), take(1));
    const userPreferencesLanguageChanged$ = action$.pipe(ofType('USER_PREFERENCES_LANGUAGE_CHANGED'));

    return merge(
      firstUserPreferencesReceived$.pipe(map(({ data }) => data.languageIsoCode)),
      userPreferencesLanguageChanged$.pipe(map(({ language }) => language)),
    ).pipe(
      tap(language => {
        document.documentElement.setAttribute('lang', language);
      }),
      ignoreElements(),
    );
  };
}
